Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-loyalty-invite-friend-form'), form, formData = {};

    if ($form.length <= 0) return;

    form = $form.get(0);

    formData = {
        email1: "",
        email2: "",
        email3: "",
        email4: "",
        email5: "",
        reCaptchaCode: ""
    };

    /* -------- reCAPTCHA --------- */
    var captchaWidgetId;
    var captchaId = "registrationCaptcha";
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {

        if (!captchaEnabled) return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.validateRecaptcha = function () {

        if (!captchaEnabled) return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        } else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.resetRecaptcha = function () {
        if (captchaEnabled) grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };
    /* -------- end of reCAPTCHA --------- */

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;

        if (response.success) {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();

            if (response.data.AppliedEmails.length > 0) {
                response.data.AppliedEmails.forEach(function (email) {
                    $('.js-applied-emails', $form).append('<span class="applied-emails">' + email + '</span>');
                });

                $('.js-applied-emails', $form).show();
            }

            if (response.data.ExistingEmails.length > 0) {
                response.data.ExistingEmails.forEach(function (email) {
                    $('.js-existing-emails', $form).append('<span class="existing-emails">' + email + '</span>');
                });

                $('.js-existing-emails', $form).show();
            }

            $('html,body').animate({ scrollTop: 0 }, 300);
        } else {
            $('.js-error', $form).html(response.message).show();
            $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);
        }

        form.resetRecaptcha();
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;

        $('.js-error', $form).html(response.message).show();
        $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);

        form.resetRecaptcha();
    };

    form.submit = function () {
        form.loading(true);

        $('input,textarea:not([name="g-recaptcha-response"])', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        //get only object properties with value
        var finalFormData = pick(formData, Object.keys(formData).filter(function (x) { return x !== "" }));
       

        Vendd.MessageBus.publishAsync(form, new Vendd.Loyalty.Messages.InviteFriends(finalFormData))
    };

    //init validation options
    var valOpts = {};

    //add email validation
    if ($('input[name="email1"]', $form).length > 0)
        valOpts['email1'] = { isEmail: 'email1-invalid' };

    if ($('input[name="email2"]', $form).length > 0)
        valOpts['email2'] = { isEmail: 'email2-invalid' };

    if ($('input[name="email3"]', $form).length > 0)
        valOpts['email3'] = { isEmail: 'email3-invalid' };

    if ($('input[name="email4"]', $form).length > 0)
        valOpts['email4'] = { isEmail: 'email4-invalid' };

    if ($('input[name="email5"]', $form).length > 0)
        valOpts['email5'] = { isEmail: 'email5-invalid' };

    $form.validationEngine(valOpts);
    var ivf = $form.data('validationEngine');

    $form.on('click', '.js-submit-button', function (e) {

        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('disabled')) return;

        var val1 = form.validateRecaptcha();
        var val2 = ivf.validate();

        if (val1 && val2) {
            form.submit();
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error', $form).first().offset().top - 100 }, 600);
            }
        }
    });

    $form.on('keyup', 'input[name]', function (e) {
        var $this = $(this);
        var fieldName = $this.attr('name');

        ivf.validate(fieldName);
    });

    $form.on('keyup', 'input[name]', function (e) {
        var $this = $(this);
        var hasValue = false;

        //check if there is input with value
        $('input', $form).each(function (index) {
            if ($(this).val()) hasValue = true;
        });

        //enable / disable submit button
        if (hasValue && $('.js-submit-button', $form).hasClass('disabled')) {
            $('.js-submit-button', $form).removeClass('disabled');
        } else if (!hasValue && !$('.js-submit-button', $form).hasClass('disabled')) {
            $('.js-submit-button', $form).addClass('disabled');
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.InviteFriendsSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.InviteFriendsFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

});